import { useTranslation } from 'react-i18next';
import SelectField from '../../core/components/Fields/SelectField.tsx';
import * as React from 'react';
import { REPLACEMENT_WEEKDAY_OPTIONS } from '../constants.ts';

const DeliveryDateRangeReplacementSelectField = (props: React.ComponentPropsWithRef<typeof SelectField>) => {
    const { t } = useTranslation('config');

    return (
        <SelectField
            {...props}
            // @ts-ignore the option values are numbers, SelectField types them as strings
            options={REPLACEMENT_WEEKDAY_OPTIONS.map(({ value, labelKey }) => ({ label: t(labelKey), value }))}
        />
    );
};

export default DeliveryDateRangeReplacementSelectField;
